import { action, makeObservable, observable } from 'mobx';

import Logger from '../../../app/shared/Logger';
import { ModalState } from '../../../app/shared/ModalState';
import { ConfirmationModalTranslation } from '../../localization/ModuleTranslation';
import { showToast } from '../../ui/Toast/Toast';

interface PendingAction {
  /** What the modal asks, naming what is about to happen to what. */
  message: string;
  /** What the toast says once it has run. */
  successMessage: string;
  translation: ConfirmationModalTranslation;
  run: () => Promise<void>;
}

export default class ConfirmationModalState extends ModalState {
  @observable public errorMessage = '';
  @observable public isPending = false;
  @observable.ref public pendingAction: PendingAction | null = null;

  public constructor() {
    super();
    makeObservable(this);
  }

  @action.bound
  public ask(pendingAction: PendingAction): void {
    this.pendingAction = pendingAction;
    this.open();
  }

  @action.bound
  public async confirm(): Promise<void> {
    if (!this.pendingAction || this.isPending) {
      return;
    }

    this.setIsPending(true);
    this.setErrorMessage('');

    try {
      await this.pendingAction.run();
      this.close();
      showToast(this.pendingAction.successMessage);
    } catch (error) {
      Logger.exception('The confirmed action failed', error);
      this.setErrorMessage(this.pendingAction.translation.error);
    } finally {
      this.setIsPending(false);
    }
  }

  protected onBeforeClose(): void {
    this.setErrorMessage('');
  }

  @action
  private setErrorMessage(errorMessage: string): void {
    this.errorMessage = errorMessage;
  }

  @action
  private setIsPending(isPending: boolean): void {
    this.isPending = isPending;
  }
}
